(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/single-rows.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/single-rows.js');

'use strict';

svs.numbergames.game.views.SingleRows = Marionette.CollectionView.extend({
  className: 'numbergames-single-rows grid-row',
  childView: svs.numbergames.game.views.SingleRow,
  childViewEventPrefix: false,
  childViewTriggers: {
    rowKeydown: 'childview:rowKeydown',
    numbersKeydown: 'childview:numbersKeydown',
    clearRowKeydown: 'childview:clearRowKeydown'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
    channel: svs.numbergames.game.huxfluxRadio
  }],
  radioEvents: {
    'huxflux:start': 'huxfluxStarted',
    'huxflux:end': 'huxfluxEnded'
  },
  huxfluxStarted(model) {
    const view = this.children.findByModel(model);
    if (view) view.triggerMethod('huxfluxStarted');
  },
  huxfluxEnded(model) {
    const view = this.children.findByModel(model);
    if (view) view.triggerMethod('huxfluxEnded');
  },
  onChangeRowPriceMulti(multipliedRowPrice) {
    this.children.forEach(child => child.triggerMethod('updateMultipliedRowPrice', multipliedRowPrice));
  },
  onArrowKeyNavigation() {
    const view = this.children.findByModel(this.collection.getActive());
    if (view) {
      view.triggerMethod('focus');
    }
  },
  onActivateTabNavigation() {
    this.children.forEach(view => view.triggerMethod('toggleKeyboardNavigation', 0));
  },
  onInactivateTabNavigation() {
    this.children.forEach(view => view.triggerMethod('toggleKeyboardNavigation', -1));
  },
  onChildviewRowKeydown(currentChild, event) {
    let child;
    switch (event.key) {
      case 'Enter':
      case ' ':
        currentChild.triggerMethod('keyboardActivateRow');
        break;
      case 'ArrowUp':
        child = this.getPreviousChildView(currentChild);
        child.triggerMethod('focus');
        break;
      case 'ArrowDown':
        child = this.getNextChildView(currentChild);
        child.triggerMethod('focus');
        break;
      case 'ArrowRight':
        if (currentChild.model.get('isEmpty')) {
          child = this.getNextChildView(currentChild);
          child.triggerMethod('focus');
        } else {
          currentChild.triggerMethod('focusNumbers');
        }
        break;
      case 'ArrowLeft':
        child = this.getPreviousChildView(currentChild);
        if (child.model.get('isEmpty')) {
          child.triggerMethod('focus');
        } else {
          child.triggerMethod('focusClearButton');
        }
        break;
      default:
        return;
    }
    event.preventDefault();
    event.stopPropagation();
  },
  onChildviewNumbersKeydown(currentChild, event) {
    let child;
    switch (event.key) {
      case 'ArrowLeft':
        currentChild.triggerMethod('focus');
        break;
      case 'ArrowRight':
        if (currentChild.model.get('isEmpty')) {
          child = this.getNextChildView(currentChild);
          child.triggerMethod('focus');
        } else {
          currentChild.triggerMethod('focusClearButton');
        }
        break;
      case 'ArrowUp':
        child = this.getPreviousChildView(currentChild);
        child.triggerMethod('focus');
        break;
      case 'ArrowDown':
        child = this.getNextChildView(currentChild);
        child.triggerMethod('focus');
        break;
      default:
        return;
    }
    event.preventDefault();
    event.stopPropagation();
  },
  onChildviewClearRowKeydown(currentChild, event) {
    let child;
    switch (event.key) {
      case 'Enter':
      case ' ':
        currentChild.triggerMethod('keyboardClearRow');
        break;
      case 'ArrowLeft':
        currentChild.triggerMethod('focusNumbers');
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        child = this.getNextChildView(currentChild);
        child.triggerMethod('focus');
        break;
      case 'ArrowUp':
        child = this.getPreviousChildView(currentChild, 1);
        child.triggerMethod('focus');
        break;
      default:
        return;
    }
    event.preventDefault();
    event.stopPropagation();
  },
  getNextChildView(currentChild) {
    const index = this.collection.indexOf(currentChild.model) + 1;
    const model = this.collection.at(index) || this.collection.first();
    return this.children.findByModel(model);
  },
  getPreviousChildView(currentChild) {
    const index = this.collection.indexOf(currentChild.model) - 1;
    const model = this.collection.at(index) || this.collection.last();
    return this.children.findByModel(model);
  }
});

 })(window);